// Import types
import { Promotion } from 'types/api/promotion';

export type CalculatedPriceProduct = {
	uuid: string;
	current_price: number;
	next_price: number;
	standard_price: number;
	is_basic: boolean;
	promotion: Promotion | null;
};

export interface CalculatedPrice {
	current_price: number;
	next_price: number;
	standard_price: number;
	billing_period_start_on: string;
	billing_period_end_on: string;
	products: CalculatedPriceProduct[];
}

export enum CalculatePriceAction {
	New = 'new_subscription',
	Upgrade = 'upgrade_subscription',
	Downgrade = 'downgrade_subscription',
	AdditionalProducts = 'add_additional_products'
}

export type CalculatePricePayloadProduct = {
	uuid: string;
	price_id: number | null;
};


